import { injectable, inject } from 'inversify';
import JsonRpcDispatcher, { interceptors } from '@dealroadshow/json-rpc-dispatcher';
import DITypes from './DI/types';
import type { IAdapterFactory } from './DI/interfaces';
import Container from '@framework/di/Container';
import addSessionData from '@users/session/interceptors/rpc/addSessionData';
import checkSession from '@users/session/interceptors/rpc/checkSession';
import userPermissionsErrorHandler from '@condor/json-rpc-dispatcher/interceptors/rpc/userPermissionsErrorHandler';
import parseWrappedError from '@framework/api/Rpc/parseWrappedError';
import OTelInstrument from '@framework/otel/OTelInstrument';
import usersUrl from '@users/url';

@injectable()
export class Dispatcher extends JsonRpcDispatcher {
  constructor(
    @inject(Container) readonly container: Container,
    @inject(DITypes.AdapterFactory) readonly adapterFactory: IAdapterFactory,
  ) {
    super(adapterFactory.create(usersUrl.getRpcUrl(), { otelPropagation: true }));

    this.interceptRequest(addSessionData(container))
      .interceptResponse(checkSession(container))
      .interceptResponse(userPermissionsErrorHandler(container))
      .interceptResponse(parseWrappedError())
      .interceptResponse(interceptors.response.transformErrorToException);

    OTelInstrument<typeof this.call>(
      this,
      'call',
      container,
      (request) => `rpc.call: ${ request.method }`,
      (request) => {
        return {
          attributes: {
            'rpc.method': request.method,
          },
        };
      },
    );
  }
}
